import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/leads/add-leads',
      name: 'add-leads',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "add-leads" */ './views/modules/leads/AddLeads.vue')
    },
    {
      path: '/leads/view-leads',
      name: 'view-leads',
      component: () => import(/* webpackChunkName: "view-leads" */ './views/modules/leads/ViewLeads.vue')
    },
    {
      path: '/payments',
      name: 'payments',
      component: () => import(/* webpackChunkName: "payments" */ './views/modules/payments/Payments.vue')
    },
    {
      path: '*',
      name: 'home',
      component: Home
    }
  ]
})
